/* TITAN SIGNS — Shopify configurator data. Keyed by product handle.
   TIERED PRICING (2026-07-16): tier 1 = Signs365's 1-9 price minus 10%;
   upper tiers MATCH S365 volume prices (rounded down to the cent).
   Sheet products tier by production sheets consumed (nesting); sqft
   products tier by total billable sqft. Rate arrays index by tier;
   plain numbers = flat pricing. Sweep: S365_pricing_sweep_2026-07-16.md.
   freeFinishing: hems + grommets included (matches S365 on HD & mesh). */
window.TITAN_CONFIG = {
  addonPrices: {
    grommetEach: 0.35,
    stakeEach: 1.40,
    glossPerSqft: 0.45,
    contourPerSqft: 0.50,
    hemPerLnft: 0.30,
    ropePerLnft: 0.25,
    polePocketPerLnft: 1.25,
    windSlitsFlat: 5.00,
    drillHoleEach: 0.50,
    roundCornersFlat: 2.50,
  },
  grommetPresets: [
    { id: "corners",    name: "Corners Only",  edges: ["corners"] },
    { id: "allsides",   name: "All Sides",     edges: ["top","bottom","left","right"] },
    { id: "topbottom",  name: "Top & Bottom",  edges: ["top","bottom"] },
    { id: "leftright",  name: "Left & Right",  edges: ["left","right"] },
    { id: "toponly",    name: "Top Only",      edges: ["top"] },
    { id: "bottomonly", name: "Bottom Only",   edges: ["bottom"] },
  ],
  grommetSpacings: [
    { name: "Every 2 Feet",   inches: 24 },
    { name: "Every 2–3 Feet", inches: 30 },
    { name: "Every 1–2 Feet", inches: 18 },
    { name: "Every 6–12 In",  inches: 9 },
  ],
  /* labels for the pricing popup's tier columns */
  tierLabels: {
    sheets: ["1–9 sheets", "10+ sheets", "Volume"],
    sqft: ["Under 1,000 sqft", "1,000+ sqft", "2,500+ sqft", "5,000+ sqft"],
  },
  products: {
    "coroplast-yard-signs": {
      name: "Coroplast Yard Signs",
      pricing: { type: "sheet", sheetW: 48, sheetH: 96,
        tierBy: "sheets", tiers: [1, 10, 51],
        tierNames: ["1–9 sheets", "10–50 sheets", "51+ sheets"],
        rates: {
          "4mm":  { label: "4mm",  single: [39.60, 33.00, 30.00], double: [49.50, 44.00, 40.00] },
          "10mm": { label: "10mm", single: [63.00, 60.00, 55.00], double: [81.00, 75.00, 65.00] },
        } },
      defaultSize: { w: 24, h: 18 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "stakes", "gloss", "contour"],
      production: "24-Hour Production",
    },
    "acrylic-photo-panels": {
      name: "Acrylic Photo Panels",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: { "3/16\"": { label: "3/16\"", single: 12.96 } } },
      minSqftPerSign: 1,
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["contour", "drillHoles"],
      production: "48-Hour Production",
    },
    "foam-board": {
      name: "Foam Board",
      pricing: { type: "sheet", sheetW: 48, sheetH: 96,
        tierBy: "sheets", tiers: [1, 10, 51],
        tierNames: ["1–9 sheets", "10–50 sheets", "51+ sheets"],
        rates: { "3/16\"": { label: "3/16\"", single: [63.00, 55.00, 50.00], double: [72.00, 65.00, 60.00] } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "contour"],
      production: "24-Hour Production",
    },
    "pvc-board": {
      name: "PVC Board",
      pricing: { type: "sheet", sheetW: 48, sheetH: 96,
        tierBy: "sheets", tiers: [1, 10, 18],
        tierNames: ["1–9 sheets", "10–17 sheets", "18+ sheets"],
        rates: {
          "3mm": { label: "3mm", single: [58.50, 55.00, 50.00], double: [76.50, 70.00, 60.00] },
          "6mm": { label: "6mm", single: [85.50, 85.00, 75.00], double: [103.50, 100.00, 85.00] },
        } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "gloss", "contour", "drillHoles"],
      production: "24-Hour Production",
    },
    "styrene": {
      name: "Styrene",
      pricing: { type: "sheet", sheetW: 48, sheetH: 96,
        tierBy: "sheets", tiers: [1, 10, 51],
        tierNames: ["1–9 sheets", "10–50 sheets", "51+ sheets"],
        rates: { "0.030\"": { label: "0.030\"", single: [49.50, 45.00, 40.00], double: [58.50, 55.00, 50.00] } } },
      defaultSize: { w: 22, h: 28 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "contour"],
      production: "24-Hour Production",
    },
    "aluminum-signs": {
      name: "Aluminum Signs",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        rates: {
          "0.040\"": { label: "0.040\"", single: 7.77, double: 9.07 },
          "0.080\"": { label: "0.080\"", single: 12.96, double: 14.25 },
        },
        sheet: { rates: {
          "0.040\"": { label: "0.040\"", single: 157.50, double: 180.00 },
          "0.080\"": { label: "0.080\"", single: 270.00, double: 292.50 },
        } } },
      minSqftPerSign: 1,
      defaultSize: { w: 18, h: 24 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "gloss", "contour", "drillHoles"],
      production: "48-Hour Production",
    },
    "aluminum-composite-acm": {
      name: "Aluminum Composite (ACM)",
      pricing: { type: "sheet", sheetW: 48, sheetH: 96,
        rates: {
          "3mm": { label: "3mm", single: 144.00, double: 162.00 },
          "6mm": { label: "6mm", single: 198.00, double: 234.00 },
        } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "gloss", "contour", "drillHoles"],
      production: "24-Hour Production",
    },
    "backlit-polycarbonate": {
      name: "Backlit Polycarbonate",
      pricing: { type: "sqft", sheetW: 48, sheetH: 96,
        tierBy: "sqft", tiers: [1, 1000, 5000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft", "5,000+ sqft"],
        rates: { "0.010\"": { label: "0.010\"", single: [3.60, 3.00, 3.00] } } },
      defaultSize: { w: 36, h: 72 }, maxSize: { w: 48, h: 96 },
      options: [],
      production: "48-Hour Production",
    },
    "bubble-board": {
      name: "Bubble Board",
      pricing: { type: "sheet", sheetW: 48, sheetH: 96,
        rates: { "4mm": { label: "4mm", single: 45.00, double: 54.00 } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 48, h: 96 },
      options: ["doubleSided", "grommets", "contour"],
      production: "24-Hour Production",
    },
    "hd-vinyl-banner": {
      name: "HD Vinyl Banner",
      freeFinishing: true,
      pricing: { type: "sqft",
        tierBy: "sqft", tiers: [1, 1000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft"],
        rates: {
          "13oz": { label: "13oz", single: [1.12, 1.00] },
          "15oz": { label: "15oz", single: [1.57, 1.25] },
          "18oz": { label: "18oz", single: [2.02, 1.75], double: [3.82, 3.25] },
        } },
      defaultSize: { w: 72, h: 36 }, maxSize: { w: 600, h: 120 },
      options: ["doubleSided", "hem", "rope", "grommets", "polePockets", "windSlits"],
      production: "24-Hour Production",
    },
    "mesh-banner": {
      name: "Mesh Banner",
      freeFinishing: true,
      pricing: { type: "sqft",
        tierBy: "sqft", tiers: [1, 1000, 2500, 5000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft", "2,500+ sqft", "5,000+ sqft"],
        rates: { "8oz": { label: "8oz Mesh", single: [2.19, 1.49, 1.09, 0.99] } } },
      defaultSize: { w: 96, h: 48 }, maxSize: { w: 600, h: 120 },
      options: ["hem", "grommets", "polePockets"],
      production: "24-Hour Production",
    },
    "hdpe-banner": {
      name: "HDPE Banner",
      pricing: { type: "sqft",
        tierBy: "sqft", tiers: [1, 1000, 5000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft", "5,000+ sqft"],
        rates: { "hdpe": { label: "HDPE Paper", single: [1.35, 1.00, 0.75] } } },
      defaultSize: { w: 36, h: 72 }, maxSize: { w: 60, h: 600 },
      options: ["grommets"],
      production: "24-Hour Production",
    },
    "canvas-banner": {
      name: "Canvas Banner",
      pricing: { type: "sqft",
        tierBy: "sqft", tiers: [1, 1000, 5000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft", "5,000+ sqft"],
        rates: { "11oz": { label: "11oz Canvas", single: [4.48, 3.79, 2.49] } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 60, h: 120 },
      options: [],
      production: "48-Hour Production",
    },
    "photo-paper-poster": {
      name: "Photo Paper Poster",
      pricing: { type: "sqft",
        tierBy: "sqft", tiers: [1, 1000, 5000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft", "5,000+ sqft"],
        rates: { "8mil": { label: "8mil Paper", single: [1.80, 1.50, 1.00] } } },
      defaultSize: { w: 24, h: 36 }, maxSize: { w: 60, h: 120 },
      options: [],
      production: "24-Hour Production",
    },
    "no-curl-banner": {
      name: "No-Curl Banner",
      pricing: { type: "sqft",
        tierBy: "sqft", tiers: [1, 1000],
        tierNames: ["Under 1,000 sqft", "1,000+ sqft"],
        rates: { "8mil": { label: "8mil No-Curl", single: [2.70, 2.00] } } },
      defaultSize: { w: 33, h: 78 }, maxSize: { w: 60, h: 120 },
      options: [],
      production: "24-Hour Production",
    },
    "vehicle-magnets": {
      name: "Vehicle Magnets",
      pricing: { type: "sqin", rates: { "30mil": { label: "30mil", single: 0.063 } } },
      defaultSize: { w: 18, h: 12 }, minSize: { w: 2, h: 3 }, maxSize: { w: 96, h: 24 },
      options: ["contour", "roundCorners"],
      production: "24-Hour Production",
    },
  },
};
